import { grey } from "../colors/index.js";
const defaultColor = (mode)=>'light' === mode ? {
        main: grey["400"],
        highContrast: grey["700"],
        lowContrast: grey["150"]
    } : {
        main: grey["400"],
        highContrast: grey["150"],
        lowContrast: grey["800"]
    };
export { defaultColor };

//# sourceMappingURL=default.js.map